import React from 'react';
import { connect } from 'react-redux';

import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner';
import userManager from '../../userManager';
import { IApplicationState } from '../../store/applicationState';

interface IOwnProps {
    user: any;
}

class LogInIndex extends React.Component<IOwnProps, {}> {
    public async componentDidMount() {
        await this.signIn();
    }

    public async componentDidUpdate(prevProps: IOwnProps) {
        if (prevProps.user !== this.props.user && (!this.props.user || this.props.user.expired)) {
            await this.signIn();
        }
    }

    public render() {
        return <React.Fragment>
            <section className="section">
                <div className="deck">
                    <div className="w--md">
                        <article className="article article--no-initial">
                            <div className="rich-text">
                                <Spinner size={SpinnerSize.Large} />
                            </div>
                        </article>
                    </div>
                </div>
            </section>
        </React.Fragment>;
    }

    private signIn = async () => {
        const mngr = await userManager;

        try {
            //console.log('LoginIndex signIn invoked', this.props.user);
            await mngr.signinSilent();
        }
        catch (e) {
            //console.log('LoginIndex silent signInSilent failed, redirecting');
            await mngr.signinRedirect({ data: { redirectUrl: window.location.href.substring(`${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/`.length) } });
        }
    }
}

const mapStateToProps = (state: IApplicationState) => {
    return { user: state.oidc.user }
}

const container = connect(mapStateToProps)(LogInIndex);

export default container;